import { useAuth0 } from '@auth0/auth0-react';
import { Box, Button, Link, Typography } from '@mui/material';

export const AccountBlockedError = () => {
  const { logout } = useAuth0();

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userInfo');
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <Box
      sx={{
        minHeight: '100dvh',
        width: '100%',
        bgcolor: '#F4F1F8',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: { xs: 4, sm: 8 },
        px: { xs: 2, sm: 3 },
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: '500px',
          bgcolor: 'background.paper',
          border: 1,
          borderColor: 'divider',
          borderRadius: 2,
          p: { xs: 3, sm: 4 },
          boxShadow: 1,
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 3 }}>
          Unable to Log In
        </Typography>

        <Typography sx={{ mb: 2 }}>There is an issue with logging into your account.</Typography>

        <Typography sx={{ mb: 4 }}>
          Please contact our support team at{' '}
          <Link href="mailto:support@jotpsych.com" sx={{ fontWeight: 'medium' }}>
            support@jotpsych.com
          </Link>{' '}
          and we&apos;ll help you get back in.
        </Typography>

        <Button variant="contained" color="primary" onClick={handleLogout} fullWidth>
          Return to Login
        </Button>
      </Box>
    </Box>
  );
};
